import {
  INIT_TRIGGER_FORM_SUCCESS,
  INIT_TRIGGER_FORM_FAILED,
  TRIGGER_FORM_SELECTED,
  INIT_TRIGGER_FORM_RESET,
} from 'actions/incidentManagement/initTriggerForm';

const initialState = {
  error: null,
  success: false,
  selectedTriggerFormId: null,
  automations: {},
};

export default function initTriggerForm(state = initialState, action) {
  switch (action.type) {
    case INIT_TRIGGER_FORM_SUCCESS: {
      const existing = state.automations[action.payload.automationId] || [];
      existing.push(action.payload);
      return {
        error: null,
        success: true,
        ...action.payload,
        automations: {
          ...state.automations,
          [action.payload.automationId]: existing,
        },
      };
    }
    case INIT_TRIGGER_FORM_FAILED: {
      return {
        success: false,
        error: action.payload,
      };
    }
    case TRIGGER_FORM_SELECTED:
      return {
        error: null,
        success: false,
        selectedTriggerFormId: action.payload.triggerFormId,
        automations: state.automations,
      };
    case INIT_TRIGGER_FORM_RESET:
      return {
        ...initialState,
      };
    default: {
      return state;
    }
  }
}
